import * as authQueries from "supabase/auth/queries.ts"
import * as authMutations from "supabase/auth/mutations.ts"
import * as dataQueries from "supabase/data/queries.ts"
import * as dataMutations from "supabase/data/mutations.ts"
import * as routeQueries from "supabase/routes/queries.ts"
import * as heavenlyCultureCampaignQueries from "supabase/heavenlyCultureCampaign/queries.ts"
import * as contentQueries from "supabase/content/queries.ts"
import * as defaultThumbnailsQueries from "supabase/default_thumbnails/queries.ts"
import * as bookmarkQueries from "supabase/bookmark/queries.ts"
import * as bookmarkMutations from "supabase/bookmark/mutations.ts"

export type ApiResponse<T> = {
    status: boolean,
    data: T | T[] | null,
    error: string | null
}

export const api = {
    authQueries,
    authMutations,
    dataQueries,
    dataMutations,
    routeQueries,
    heavenlyCultureCampaignQueries,
    contentQueries,
    defaultThumbnailsQueries,
    bookmarkQueries,
    bookmarkMutations,
}